import { render, staticRenderFns } from "./UiSnackbar.vue?vue&type=template&id=61a59f92"
import script from "./UiSnackbar.vue?vue&type=script&lang=js"
export * from "./UiSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports